import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Link,
  Box,
} from "@mui/material";
import union_img from "../../assets/baseVersion/Union.svg";
import { useAuth, useStorageManager, useTokens } from "../../shared/hooks";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

interface ExpiredAccountDialogProps {
  open: boolean;
  onClose: () => void;
  onDelete: () => void;
  userData?: any;
  isNewUserDetails?: any;
  onupgrade?: () => void;
}

const ExpiredAccountDialog: React.FC<ExpiredAccountDialogProps> = ({
  open,
  onClose,
  onDelete,
  onupgrade,
 
}) => {
  //console.log(userData, "userData");
  const { getFromLocalStorage } = useStorageManager();
  //console.log(isNewUserDetails, "isNewUserDetails");
  const [isNewUserDetails,setIsNewUserDetails] = useState<any>({});
  const [userDetails, setUserDetails] = useState<any>({});

  const navigate = useNavigate();
  const { logout } = useAuth();
  const { clearTokens } = useTokens();
  const [isViewPlans, setIsViewPlans] = useState(false);

  useEffect(() => {
      console.log(getFromLocalStorage("userDetails"));
      const data = JSON.parse(getFromLocalStorage("userDetails") || "{}");
      console.log(data);
      setUserDetails(data);
      setIsNewUserDetails(JSON.parse(getFromLocalStorage("isNewUserDetails") || "{}"));
      console.log(data, "userDetails");
      console.log(isNewUserDetails, "isNewUserDetails");

      
      
    }, []);

  const HandleSignout=async ()=>{
    await logout();
    clearTokens();
    navigate("/login");
  }

  const handleClose = (e: any, reason: string) => {
    console.log(reason);
    if (reason === "escapeKeyDown" || reason === "backdropClick") {
      return;
    }
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
          }}
        >
          <img
            src={union_img}
            alt=""
            style={{ width: "70px", height: "70px" }}
          />
          <Typography fontWeight="bold" align="center">
            Your {userDetails?.subscription_name} account has been Expired!
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            gap: 2,
          }}
        >
          <Typography variant="body2">
            To continue, please upgrade your <strong>account</strong> with a
            paid subscription.
            <br />
            {!(
              isNewUserDetails?.new_user && isNewUserDetails?.device_count === 0
            ) && (
              <>
                Your data will be securely stored with us until{" "}
                <b>{userDetails?.expiry_date ? new Date(userDetails.expiry_date)
                  .toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
                  .replace(/\s/g, '-') : ''}</b>. After that it will be
                permanently deleted.
              </>
            )}
          </Typography>
          <Typography variant="body2" mt={2}>
            You can choose to delete your data right away.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
          p: 2,
        }}
      >
        <div style={{ display: "flex", flexDirection: "row", gap: 20 }}>
          {/* <Button variant="contained" color="primary" style={{ width: 150 }} onClick={onupgrade}>
            Upgrade!
          </Button> */}
          <Button
            variant="outlined"
            onClick={onClose}
            sx={{
              width: 150,
              color: "#FB4B50",
              borderColor: "#FB4B50",
              "&:hover": {
                color: "#fff",
                borderColor: "#FB4B50",
                backgroundColor: "#FB4B50",
              },
            }}
            onClickCapture={HandleSignout}
          >
            Sign Out
          </Button>
        </div>
        {true ? (
          <>
            <Typography variant="caption" align="center" sx={{ mt: 1 }}>
             <Link
  underline="hover"
  sx={{
    color: "text.disabled",
    pointerEvents: "none",
    cursor: "not-allowed",
    textDecoration: "none",
  }}
>
  Download Data
</Link>
              &nbsp; | &nbsp;
              <Link href="#" color="error" underline="hover" onClick={onDelete}>
                Delete data permanently
              </Link>
            </Typography>
          </>
        ) : (
          <>
            {/* <Link href="#" color="error" underline="hover" onClick={onDelete}>
              Delete data permanently
            </Link> */}
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ExpiredAccountDialog;
